import React, { useEffect, useMemo, useState } from 'react';
import { StyledDiv } from '../../../Theme/CommonStyled';
import { StyledSelect, StyledSelectContainer } from './style';
import Icon from '../Icon';
import moment from 'moment-jalaali';
import { generateDayOfMonth, yearRange } from '../../../Utils/datePicker.util';

type DatePickerType = {
  date: string;
  onChange?: (date: string) => void;
};

moment.loadPersian({ dialect: 'persian-modern' });

const DatePicker: React.FC<DatePickerType> = ({ date, onChange }) => {
  const [dayOfMonth, setDayOfMonth] = useState([]);
  const [day, setDay] = useState(0);
  const [month, setMonth] = useState(1);
  const [year, setYear] = useState(0);

  const dateValue = useMemo(() => moment(date || new Date()), []);

  useEffect(() => {
    if (dateValue) {
      setDay(dateValue.jDate());
      setMonth(dateValue.jMonth() + 1);
      setYear(dateValue.jYear());
    }
  }, [dateValue]);

  useEffect(() => {
    year && month && setDayOfMonth(generateDayOfMonth(year, month));

    if (year && month && day)
      onChange(
        moment(`${year}/${month}/${day}`, 'jYYYY/jM/jD').format('YYYY-MM-DD')
      );
  }, [year, month, day]);

  return (
    <StyledDiv display="flex" width="100%" gap={10} mb={6} direction="rtl">
      <StyledSelectContainer flex={2}>
        <StyledSelect
          value={day}
          onChange={(e) => setDay(Number(e.target.value))}>
          {dayOfMonth.map((dayOption) => (
            <option key={dayOption}>{dayOption}</option>
          ))}
        </StyledSelect>
        <Icon name="arrow-down" fontSize={4} color="secondaryGreen" />
      </StyledSelectContainer>
      <StyledSelectContainer flex={5}>
        <StyledSelect
          value={month}
          onChange={(e) => setMonth(Number(e.target.value))}>
          {Array.from(
            {
              length: 12
            },
            (_, index) => index + 1
          ).map((monthOption) => (
            <option key={monthOption} value={monthOption}>
              {moment()
                .jMonth(monthOption - 1)
                .format('jMMMM')}
            </option>
          ))}
        </StyledSelect>
        <Icon name="arrow-down" fontSize={4} color="secondaryGreen" />
      </StyledSelectContainer>
      <StyledSelectContainer flex={3}>
        <StyledSelect
          value={year}
          onChange={(e) => setYear(Number(e.target.value))}>
          {yearRange().map((yearOption) => (
            <option key={yearOption}>{yearOption}</option>
          ))}
        </StyledSelect>
        <Icon name="arrow-down" fontSize={4} color="secondaryGreen" />
      </StyledSelectContainer>
    </StyledDiv>
  );
};

export default DatePicker;
